import React from 'react';

import RunDetails from './RunDetails';

export default function RunDetailsTabView({runId}: {runId: string}): JSX.Element {
  return (
    <div className="react-tab-container">
      <RunDetails runId={runId} />
    </div>
  );
}
